import { Card, FormBloc, FormTitle } from "@endya-conformite/ui-kit";
import { ReactNode } from "react";

type SocieteInformationFormBlocProps = {
  children: ReactNode;
  title: string;
};

export function SocieteInformationFormBloc({
  children,
  title,
}: SocieteInformationFormBlocProps) {
  return (
    <FormBloc>
      <Card>
        <FormTitle>
          <h1>{title}</h1>
        </FormTitle>
        {children}
      </Card>
    </FormBloc>
  );
}
